<div class="dialog delete" *ngIf="dynamicFormFields">
  <div mat-dialog-title class="dialogHeader">
    <div class="headertitle">{{modalTitle}}</div>
  </div>
  <mat-divider></mat-divider>
  <div mat-dialog-content class="content" [innerHTML]="safeHtmlContent">
    <!-- Optional: Display status separately -->
    <p><strong>Status:</strong> {{ dynamicFormFields?.data?.status }}</p>
    <!-- Render the message with HTML (clickable link) -->
  </div>
  <mat-divider></mat-divider>
  <div *ngIf="isPayButtonVisible && !isNextButtonVisible" mat-dialog-actions class="footer">
  <button (click)="onClickPaynow()" mat-flat-button class="flat-button">Pay now</button>
</div>
  <div *ngIf="!isNextButtonVisible && !isPayButtonVisible" mat-dialog-actions class="footer">
    <button mat-flat-button class="flat-button" (click)="close()">Close</button>
  </div>

  <div *ngIf="isNextButtonVisible" mat-dialog-actions class="footer">
    <button mat-flat-button class="flat-button" (click)="next()">Next</button>
  </div>

</div>